import { baseApi } from "./api";

export interface UploadAvatarResponse {
  message: string;
  url: string;
  key: string;
}

export interface DeleteAvatarResponse {
  message: string;
}

export interface UploadThumbnailResponse {
  message: string;
  url: string;
  key: string;
}

export const uploadsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Upload avatar
    uploadAvatar: builder.mutation<UploadAvatarResponse, FormData>({
      query: (formData) => ({
        url: "/uploads/avatar",
        method: "POST",
        body: formData,
      }),
    }),

    // Delete avatar
    deleteAvatar: builder.mutation<DeleteAvatarResponse, { url: string }>({
      query: (payload) => ({
        url: "/uploads/avatar",
        method: "DELETE",
        body: payload,
      }),
    }),

    // Upload course thumbnail
    uploadCourseThumbnail: builder.mutation<UploadThumbnailResponse, FormData>({
      query: (formData) => ({
        url: "/uploads/course-thumbnail",
        method: "POST",
        body: formData,
      }),
    }),

    // Upload report screenshot
    uploadReportScreenshot: builder.mutation<UploadThumbnailResponse, FormData>({
      query: (formData) => ({
        url: "/uploads/report-screenshot",
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

export const {
  useUploadAvatarMutation,
  useDeleteAvatarMutation,
  useUploadCourseThumbnailMutation,
  useUploadReportScreenshotMutation,
} = uploadsApi;
